import React, { useState } from 'react';
import { HOURS_FILTERS } from '../../data/constants';
import { classIf } from '../../data/utils/classIf';
import { useFilters } from '../FiltersContext';
import { PrematchContext } from '../Prematch';
import { processFilters } from './MainMenuNavbar';

function NavDropdown(props) {
    const prematchContext = React.useContext(PrematchContext);
    const filtersData = useFilters();
    const [filters] = useState(() => {
        return processFilters(filtersData);
    });
    const [toggled, setToggled] = useState(false);

    function handleClick(f) {
        if (HOURS_FILTERS.includes(f.type)) {
            const dayFilter = {
                ...filters.find(f => f.date != null),
                type: f.type
            };
            prematchContext.openMultiEventsByDate(dayFilter);
        } else {
            prematchContext.setTemporalFilter(f);
        }
    }

    return (
        <div className="nav-dropdown-toggle mr-2" onClick={() => setToggled(!toggled)}>
            <span className="nav-dropdown-desc text-bold">{prematchContext.temporalFilter?.desc}<i className="fa fa-angle-down ml-1"></i></span>
            {toggled &&
                <nav className="temporal-filters-sidebar">
                    <span className="temporal-filter-tab" onClick={() => window.openSection('live')}>Live</span>
                    {filters.map(filter => {
                        const selected = prematchContext.temporalFilter.type === filter.type;
                        return (
                            <span key={filter.type} className={"temporal-filter-tab" + classIf(selected, 'selected')} onClick={() => handleClick(filter)}>{filter.desc}</span>
                        );
                    })}
                </nav>
            }
        </div>
    );
}

export default NavDropdown;